import React, { useEffect } from 'react';

import QuillModal from '@Common/quillElements/QuillModal';
import QuillLogo from './header/HeaderLogo';
import Img from '@Common/components/img';
import NewQuillBtn from '@Common/quillElements/button/NewQuillBtn';
import Link from 'next/link';
import ExpertReviewPriceBlock from '@Common/components/ExpertReviewPriceBlock';
import commonTrack from '@Common/handlers/track';

import { Box, Typography, CheckCircleOutline, Divider, useTheme } from '@quillbot/design-system';

export default function ExpertReviewModal({ open, onClose }: { open: boolean; onClose: Function }) {
  const theme = useTheme();
  useEffect(() => {
    commonTrack.userInteractedWithERModal('open');
  }, []);

  const onButtonClick = () => {
    commonTrack.clickedExpertReviewUpload('expertReviewModal');
    window.open('https://order.scribbr.com/student/quillbot-proofreading/', '_blank');
  };
  const onCloseModal = () => {
    commonTrack.userInteractedWithERModal('closed');
    onClose();
  };
  const ModalContentBlock = (
    <Box mt="-20px" px="8px">
      <Box display="flex" justifyContent="space-between">
        <Box pr="72px">
          <Typography fontSize="22px" lineHeight="31px" color="text.primary">
            Maximize your writing potential with Scribbr’s expert review service
          </Typography>
          <Box pt="16px" />
          <Box display="flex" alignItems="center">
            <CheckCircleOutline sx={{ fontSize: '16px', color: 'text.primary' }} />
            <Box pr="8px" />
            <Typography color="text.primary" fontSize="16px" lineHeight="20px">
              Provides personalized feedback
            </Typography>
          </Box>
          <Box pt="12px" display="flex" alignItems="center">
            <CheckCircleOutline sx={{ fontSize: '16px', color: 'text.primary' }} />
            <Box pr="8px" />
            <Typography color="text.primary" fontSize="16px" lineHeight="20px">
              Highlights inconsistencies and jargon
            </Typography>
          </Box>
          <Box pt="12px" display="flex" alignItems="center">
            <CheckCircleOutline sx={{ fontSize: '16px', color: 'text.primary' }} />
            <Box pr="8px" />
            <Typography color="text.primary" fontSize="16px" lineHeight="20px" whiteSpace="nowrap">
              Suggests improvements for unclear sentences
            </Typography>
          </Box>
        </Box>
        <Box flex={1} alignContent="center" textAlign="center">
          <Box display="flex" alignItems="center" marginLeft="-12px">
            <QuillLogo height={29} />
            <Typography fontSize="14px" lineHeight="14px">
              +
            </Typography>
            <Box pr="8px" />
            <Img
              height={29}
              src={`/images/theme/${theme.palette.mode}/expertReview/scribbr-logo-text.svg`}
              alt="scribbr-logo-text"
            />
          </Box>
          <Box pt="4px" />
          <Typography color="text.primary" fontSize="14px" lineHeight="17px">
            Partners in the best writing review service
          </Typography>
          <Box pt="12px" />
          <Divider />
          <Box pt="12px" />
          <Typography fontSize="14px" color="text.primary" fontWeight={600} lineHeight="18px">
            Excellent 4.9 out of 5{' '}
          </Typography>
          <Box pt="8px" />
          <Img height={24} src="/images/trustpilot-stars-5.svg" alt="stars-5" />
          <Box pt="4px" />
          <Img width={72} src={`/images/theme/${theme.palette.mode}/expertReview/trustpilot.png`} alt="trust-pilot" />
          <Box pt="8px" />
        </Box>
      </Box>
      <Box px="32px" mx="-32px" py="12px" pb="16px" bgcolor={theme.specialColors.LIGHT_BLUE_COLOR}>
        <Typography fontSize="18px" lineHeight="35px" color="text.primary">
          Calculate your price
        </Typography>
        <Box pt="4px" />
        <ExpertReviewPriceBlock variant="inline" />
        <Box pt="4px" />
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb="-20px" py="12px">
        <Box flex={1} display="flex" alignItems="center">
          <Img height={86} width={86} src="/images/happiness-guarantee.png" alt="happiness-guarantee" />
          <Box pr="12px" />
          <Typography maxWidth={256} color="text.primary" fontSize="14px" lineHeight="18px">
            We value service. Our customer happiness team is here to support you!
          </Typography>
        </Box>
        <Box pr="32px" />
        <Box width={282}>
          <Box display="flex" alignItems="center" justifyContent="flex-end">
            <Link target="_blank" href="/expert-review">
              <Typography
                fontWeight={600}
                color="#2971FE"
                fontSize="14px"
                lineHeight="22px"
                onClick={() => {
                  commonTrack.userInteractedWithERModal('learnMore');
                }}>
                Learn More
              </Typography>
            </Link>
            <Box pr="20px" />
            <Box>
              <NewQuillBtn
                style={{
                  fontWeight: 700,
                  padding: '12px 22px',
                  borderRadius: '29px',
                  lineHeight: '19px',
                }}
                className=""
                onClick={onButtonClick}
                disabled={false}
                color="primary"
                variant="contained"
                buttonText="Upload to Scribbr"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <QuillModal
      open={open}
      onClose={onCloseModal}
      isCloseBtn
      //   title="QuillBot’s Premium Modes"
      //   aria-labelledby="Premium Features"
      //   aria-describedby="Dialog box explaining premium features"
      //   ctaText="Go Premium"
      //   isPremiumCta
      //   onCtaClick={handleClose}
      //   native={platform.native}
      //   isIE={platform.isIE}
      ctaReferrer="modesModal"
      modalContent={ModalContentBlock}
    />
  );
}
